import React, { Component } from "react";
import { Link, withRouter, generatePath } from "react-router-dom";
import client from "../../../utils/client";
import billPayClientX from "../../../utils/api/billPayClientX";
import billPayClient from "../../../utils/api/billPayClient";
import billPayCreative from "../../../assets/bill-pay-creative.svg";
import serviceDownImg from "../../../assets/service-down.svg";
import Modal from "react-bootstrap/Modal";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import "react-toastify/dist/ReactToastify.css";
import { FormattedMessage, injectIntl } from "react-intl";
import aboutBlue from "../../../assets/about-blue.svg";
import ErrorModal from "../../../components/ErrorModal";
import ContentLoader from "react-content-loader";
import PartialAmount from "../components/PartialAmount";
import PastTransactions from "../components/PastTransaction";
import InlineLoader from "../../../components/InlineLoader";
import { setRepeatData } from "../actions/order";

import {
  onViewedProduct
} from "../../../utils/events";
import {
  currentlySelectedLanguage,
  isDate,
  reverseDateFormat,
} from "../../../utils/helper";
import { billPayCart, billPay } from "../actions/order";
import Iframe from "../../../components/iFrame";
import InfoDialog from "../../../components/InfoDialog";
import FormattedMessageWithClass from "../../../components/FormattedMessageWithClass";
import { FirebaseContext } from "../../../utils/firebase";
import { connect } from "react-redux";

class BillPayForm extends Component {
  static contextType = FirebaseContext;

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      service: null,
      services: [],
      providers: [],
      provider: null,
      number: null,
      amount: null,
      account: null,
      authenticator: null,
      payBtnState: true,
      circles: [],
      circle: null,
      plans: [],
      isWrpBenefitModelOpen: false,
      isFetchBill: false,
      isErrorModalOpen: false,
      isPartialAmtModalOpen: false,
      numberValidation: "",
      ad1Validation: "",
      ad2Validation: "",
      isFetchBillSuccessful: false,
      fetchBillResponse: [],
      transactions: [],
      isLoading: false,
      isBilPayMaintenance: false,
      serviceDisable: false,
      plan_id: null,
      pageNo: 0,
      isLastPage: false,
      paramID: "",
      razorpay_email: null,
      razorpay_mobile: null,
      pageLoading: false
    };

    this.handleShow = () => {
      this.setState({ show: true });
    };

    this.handleHide = () => {
      this.setState({ show: false });
    };
  }

  resetState = () => {
    this.setState({
      show: false,
      service: null,
      services: [],
      providers: [],
      provider: null,
      number: null,
      amount: null,
      account: null,
      authenticator: null,
      payBtnState: true,
      circles: [],
      circle: null,
      plans: [],
      isWrpBenefitModelOpen: false,
      isFetchBill: false,
      isErrorModalOpen: false,
      isPartialAmtModalOpen: false,
      numberValidation: "",
      ad1Validation: "",
      ad2Validation: "",
      isFetchBillSuccessful: false,
      fetchBillResponse: [],
      transactions: [],
      isLoading: false
    });
  };
  sendBillEventData = (productName) => {
    const payload = {
      category: "Utility Bill",
      productName: productName,
    };
    this.setState({ clevertapPayload: payload })
    // onViewedProduct(payload);
  };
  getProviders = (id) => {
    billPayClient.get(`/v3/services/${id}/providers`).then((response) => {
      const providers = response.data.data.providers;
      this.setState({
        providers: providers,
      });
    });
  };

  repeatOrder = (order) => {
    const payload = {
      category: "Utility Bill",
      productName: order.service_name,
      amount: order.amount,
      //  quanity: order.number,
    };

    this.initiateOrder(`v2/repeat-order`, { order_id: order.id }, payload);
  };

  componentDidMount() {
    setTimeout(() => {
      onViewedProduct(this.state.clevertapPayload);
    }, 1000);

    this.setState({ pageLoading: true })
    const {
      match: { params },
    } = this.props;

    const id = Number(params.id);
    this.setState({ paramID: id })
    if (this.props.profile) {
      this.setState({
        razorpay_email: this.props.profile.email,
        razorpay_mobile: this.props.profile.mobile
      })
      const { bill_pay } = this.context;

      this.getServices(id);
      if (!bill_pay) {
        if (this.props.order.repeatData) {
          this.repeatOrder(this.props.order.repeatData);
        }
        //sending only one time repeat order data to further then resetting to null
        this.props.repeat(null);

        this.getProviders(id);
        this.getCircles();
      } else {
        this.setState({
          isBilPayMaintenance: bill_pay,
        });
      }
    } else {
      window.location.href = `${process.env.REACT_APP_SSO_URL}/login?continue=${process.env.REACT_APP_URL}`;
    }
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll = () => {
    if (
      !this.state.isLastPage &&
      window.innerHeight + document.documentElement.scrollTop !==
      document.documentElement.offsetHeight
    ) {
      const newPageNo = this.state.pageNo + 1;
      if (newPageNo < 5)
        this.setState(
          {
            pageNo: newPageNo,
          },
          () => {
            this.getPastTransactions(this.state.pageNo, this.state.service.id);
          }
        );
    }
  };

  initiateOrder = (url, form, payload) => {
    billPayClientX
      .post(url, form)
      .then((response) => {
        this.setState({
          isLoading: false,
          // provider: response.data.data
        });
        setTimeout(() => {
          this.repeatTransaction(response.data.data)

        }, 500);
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
      });
  };

  getCircles = () => {
    // billPayClient.get(`v1/bill-pay/circles`).then((response) => {
    client.get(`v1/bill-pay/circles`).then((response) => {
      let data = response.data.data;

      this.setState({
        circles: data,
        pageLoading: false
      });
    });
  };

  filterService = (data, id) => {
    return data.filter((item) => {
      return Number(id) === Number(item.id);
    });
  };

  getServices = (id) => {
    // billPayClient.get(`v1/bill-pay/services`).then((response) => {
    client.get(`v1/bill-pay/services`).then((response) => {
      let data;
      const sortedData = response.data.data.sort((a, b) => a.id - b.id);
      if (Number(id) === 1 || Number(id) !== 2) {
        data = sortedData.filter((item) => Number(item.id) !== 2);
      } else if (Number(id) === 2) {
        data = sortedData.filter((item) => Number(item.id) !== 1);
      }
      data[0].name = "Mobile";
      const service = this.filterService(data, id);
      this.setState(
        {
          service: service[0],
          services: data,
        },
        () => {
          window.addEventListener("scroll", this.handleScroll);
          //    this.getPastTransactions(this.state.pageNo, this.state.service.id);
          this.sendBillEventData(this.state.service.name);
        }
      );
    });
  };

  getPastTransactions = (pageNo, serviceId) => {
    billPayClientX
      .get(`/v1/orders/service/${serviceId}`, {
        params: {
          page: pageNo,
        },
      })
      .then((response) => {
        let isLast;
        isLast = response.data.links.next === null;
        if (isLast) {
          window.removeEventListener("scroll", this.handleScroll);
        }
        this.setState((prevState) => ({
          ...prevState,
          transactions: prevState.transactions.concat(response.data.data),
          isLastPage: isLast,
        }));
      });
  };

  UNSAFE_componentWillReceiveProps(props) {
    this.resetState();
    const {
      match: { params },
    } = props;
    const id = Number(params.id);
    this.getServices(id);
    this.getProviders(id);
    this.getCircles();
  }

  onSelectProvider = (event) => {
    const providorID = event.target.value;
    this.setState({ circle: null });
    if (document.getElementById('prepaid') && document.getElementById('prepaid').checked === true)
      document.getElementById('default-operator').value = "-1"
    if (document.getElementById('default-mobile'))
      this.setState({ number: "" })
    if (document.getElementById('default-account'))
      this.setState({ amount: "" })
    if (document.getElementById('default-amount'))
      this.setState({ amount: "" })
    if (document.getElementById('default-consumer'))
      this.setState({ account: "" })

    if (-1 === parseInt(providorID)) {
      this.setState({
        provider: null,
      });

      return;
    }

    const provider = this.state.providers.filter((item) => {
      return Number(item.id) === Number(providorID);
    });
    if (provider[0].temp_disabled) {
      this.setState({
        serviceDisable: true,
        provider: null,
      });
    } else {
      this.setState({
        provider: provider[0],
        serviceDisable: false,
      });
    }
  };

  onSelectCircle = (event) => {
    const circleID = event.target.value;
    this.setState({ circle: circleID });
    let providerID = "";
    if (this.state.provider) {
      providerID = this.state.provider.id;
    }
    client
      .get("v1/bill-pay/plans", {
        params: {
          circle_id: circleID,
          provider_id: providerID,
        },
      })
      .then((response) => {
        this.setState({
          plans: response.data.data,
        });
      });
  };

  onMobileRechargeTypeChange = (event) => {
    const value = event.target.value;
    this.getProviders(value);
    this.props.history.push({
      pathname: generatePath(this.props.match.path, { id: value }),
    });
  };

  onChangeNumber = (event, parameter) => {
    event.persist();
    const number = event.target.value;
    this.setState(
      {
        number: number,
      },
      () => {
        if (parameter.rule) {
          const rejex = RegExp(parameter.rule);
          if (!rejex.test(number)) {
            this.setState({
              [`${parameter.key}Validation`]: `${parameter.value} is not valid`,
              payBtnState: true
            });
          } else {
            this.setState({
              [`${parameter.key}Validation`]: "",
              payBtnState: false
            });
          }
        }
      }
    );
  };

  onAmountChange = (event) => {
    const amount = event.target.value;
    const isValid = this.state.numberValidation === '' && this.state.ad1Validation === '' && this.state.ad2Validation === '';
    this.setState({
      amount: amount,
      payBtnState: isValid ? false : true
    });
  };


  onChangeAccount = (event, parameter) => {
    const account = event.target.value;
    this.setState(
      {
        account: account,
      },
      () => {
        if (parameter.rule) {
          let rejex;
          rejex = RegExp(parameter.rule);
          if (!rejex.test(account)) {
            if (parameter.value !== "Date Of Birth") {
              this.setState({
                [`${parameter.key}Validation`]: `${parameter.value} is not valid`,
              });
            }
          } else {
            this.setState({
              [`${parameter.key}Validation`]: "",
            });
          }
        }
      }
    );
  };

  onChangeAuthenticator = (event) => {
    const authenticator = event.target.value;

    this.setState({
      authenticator: authenticator,
    });
  };

  onSelectPlan = (planId, cost) => {
    this.setState({
      show: false,
      amount: cost,
      payBtnState: false,
      plan_id: planId,
    });
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.onFetchBill();
    }
  };

  onFetchBill = () => {
    let account = this.state.account;
    if (isDate(account)) {
      account = reverseDateFormat(account);
    }
    //checking the condition for fastag param id (staging=29) and (production=24)
    if (this.state.paramID === 24 || this.state.paramID === 29) {
      this.setState(
        {
          isLoading: true,
        },
        () => {
          billPayClientX
            .post(`/v1/view-bill`, {
              number: this.state.number,
              provider_id: this.state.provider.id,
              ad1: this.state.provider.name || "",
              ad2: this.state.authenticator || "",
            })
            .then((response) => {
              this.setState({
                isFetchBillSuccessful: true,
                fetchBillResponse: response.data.data.bills,
                isLoading: false,
                amount: response.data.data.bills[0].billnetamount,
              });
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
            });
        }
      );
    }
    else {
      this.setState(
        {
          isLoading: true,
        },
        () => {
          billPayClientX
            .post(`/v1/view-bill`, {
              number: this.state.number,
              provider_id: this.state.provider.id,
              ad1: account || "",
              ad2: this.state.authenticator || "",
            })
            .then((response) => {
              this.setState({
                isFetchBillSuccessful: true,
                fetchBillResponse: response.data.data.bills,
                isLoading: false,
                amount: response.data.data.bills[0].billnetamount,
              });
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
            });
        }
      );
    }
  };

  onInitOrder = () => {
    const isFound = this.state.provider.parameters.find(parameter => parameter.ishiddent);
    let account = this.state.account;
    if (isDate(account)) {
      account = reverseDateFormat(account);
    }
    if (isFound) {
      account = isFound['expected-response'];
    }

    const payload = {
      category: "Utility Bill",
      productName: this.state.service.name,
      amount: this.state.amount,
      quanity: 1,
    };

    // onPurchaseInitiated(payload);

    this.setState(
      {
        isLoading: true,
      },
      () => {
        const form = {
          provider_id: this.state.provider.id,
          number: this.state.number,
          amount: this.state.amount,
          account: account,
          authenticator: this.state.authenticator,
          wallet_enabled: 0,
          payment_mode: null,
          provider_key1: this.state.service.provider_label,
          provider_value1: this.state.provider.name,
          provider_key2: this.state.provider.parameters[0].value,
          provider_value2: this.state.number,

        };
        if (this.state.service.id === 1) {
          form.circle_id = this.state.circle;
          form.plan_id = this.state.plan_id;
        }
        // this.initiateOrder(`v2/initiate-order`, form, payload);
        this.props.billPayCart(form)
        this.props.billPay(payload)
        this.props.history.push(`/bill-pay/cart`)
      }
    );
  };

  openWrpBenefitModel = () => {
    this.setState({ isWrpBenefitModelOpen: true });
  };
  closeWrpModelHandler = () => {
    this.setState({ isWrpBenefitModelOpen: false });
  };

  onDismissErrorModal = () => {
    this.setState({
      isErrorModalOpen: false,
    });
  };

  onPartialAmtModalClose = () => {
    this.setState({
      isPartialAmtModalOpen: false,
    });
  };

  openPartialPayment = () => {
    this.setState({
      isPartialAmtModalOpen: true,
    });
  };

  ViewPlans = () => {
    return (
      <Modal size="lg" show={this.state.show} onHide={this.handleClose}>
        <Modal.Header
          closeButton
          className="border-0"
          onClick={this.handleHide}
        >
          <Modal.Title>
            <FormattedMessage
              id="billpay.choose-a-plan"
              defaultMessage="Choose a plan"
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="nav--plans">
            <Tabs>
              {this.state.plans.map((item, index) => {
                return (
                  <Tab
                    eventKey={item.category}
                    className="nav-tabs--plan"
                    title={item.category}
                    key={`category${index}`}
                  >
                    {item.plans.map((item, index) => {
                      return (
                        <div className="card mt-3" key={`plans${index}`}>
                          <div className="card-header">
                            <h3>
                              <strong>{item.cost}</strong>
                            </h3>
                          </div>
                          <div className="card-body">
                            <p className="mb-0">
                              <FormattedMessage
                                id="billpay.talktime"
                                defaultMessage="Talktime"
                              />
                            </p>
                            <p>
                              <strong>{item.talk_time}</strong>
                            </p>
                            <p className="mb-0">
                              <FormattedMessage
                                id="billpay.validity"
                                defaultMessage="Validity"
                              />
                            </p>
                            <p>
                              <strong>{item.validity}</strong>
                            </p>
                            <p className="mb-0">
                              <FormattedMessage
                                id="billpay.plan-detail"
                                defaultMessage="Plan Detail"
                              />
                            </p>
                            <p>
                              <strong>{item.description}</strong>
                            </p>
                            <button
                              className="btn btn-primary"
                              onClick={() => {
                                this.onSelectPlan(item.id, item.cost);
                              }}
                              type="button"
                            >
                              <FormattedMessage
                                id="billpay.select-plan"
                                defaultMessage="Select plan"
                              />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </Tab>
                );
              })}
            </Tabs>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            type="button"
            onClick={this.handleHide}
          >
            <FormattedMessage id="general.close" defaultMessage="Close" />
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  WrpBenefitModel = (show, onHide) => {
    return (
      <React.Fragment>
        <Modal
          // show={props.isWrpBenefitModelOpen}
          // onHide={props.closeWrpModelHandler}
          show={show}
          onHide={onHide}
          className="font-proxima-nova"
        >
          <Modal.Header closeButton className="border-0">
            <Modal.Title>
              <FormattedMessage
                id="general.wrp_benefits"
                defaultMessage="WRP Benefits"
              />
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-12 text-left">
                <p>
                  <FormattedMessage
                    id="billPay.wrp-info1"
                    defaultMessage="Any bill payment or recharge done will earn you flat
                  WRP."
                  />
                  &nbsp;{" "}
                  <FormattedMessage
                    id="billPay.wrp-info2"
                    defaultMessage="WRP will be awarded immediately after the
                  completion of payment or recharge."
                  />
                </p>


                <div className="mt-2">
                  <p className="font-proxima-nova-bold">
                    <FormattedMessage
                      id="billPay.wrp-earning"
                      defaultMessage="WRP Earning"
                    />{" "}
                    :
                  </p>

                  <p>
                    <FormattedMessage
                      id="billPay.wrp-dummy1"
                      defaultMessage={"Rs 100 Spent =  " + this.state.providers[0]?.wrp_ratio * 100 + " WRP"}
                    />{" "}
                  </p>
                </div>



                <div className="mt-4">
                  <p className="font-proxima-nova-bold">
                    <FormattedMessage
                      id="billPay.example"
                      defaultMessage="Example"
                    />{" "}
                    :
                  </p>
                  <p>
                    <FormattedMessage
                      id="billPay.wrp-dummy1"
                      defaultMessage={"Payment Value: Rs 500"}
                    />{" "}
                  </p>
                  <p>
                    <FormattedMessage
                      id="billPay.wrp-dummy1"
                      defaultMessage={"WRP Earned: " + ((this.state.providers[0]?.wrp_ratio / 1) * 500) + " WRP"}
                    />{" "}
                  </p>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="border-0">
            <Link to="/wrp-details">
              <button className="btn btn-primary">
                <FormattedMessage
                  id="home.know-more"
                  defaultMessage="Know More"
                />
              </button>
            </Link>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  };

  onPartialAmountChange = (value) => { };
  repeatTransaction = (item) => {
    const providers = this.state.providers;
    const providerId = item.pay_bill_request.provider_id;
    const params = item.pay_bill_request.params;
    const circleID = item.pay_bill_request.circle_id;

    // resetting plans after clicking repeat/retry buttons
    client
      .get("v1/bill-pay/plans", {
        params: {
          circle_id: circleID,
          provider_id: providerId,
        },
      })
      .then((response) => {
        this.setState({
          plans: response.data.data,
        });
      });

    if (circleID) {
      const circle = this.state.circles.filter((item) => item.id === circleID);
      this.setState({
        circle: circle[0].id,
      });
    }
    this.setState({
      amount: item.amount,
      payBtnState: false
    });

    for (let i = 0, paramsLength = params.length; i < paramsLength; i++) {
      const param = params[i];
      if (param.key === "number") {
        this.setState({
          number: param.value,
        });
      }
      if (param.key === "ad1") {
        this.setState({
          account: param.value,
        });
      }
      if (param.key === "ad2") {
        this.setState({
          authenticator: param.value,
        });
      }
    }

    const provider = this.filterService(providers, providerId);
    if (provider[0].temp_disabled) {
      this.setState({
        serviceDisable: true,
        provider: null,
      });
    } else {
      this.setState({
        provider: provider[0],
        serviceDisable: false,
      });
    }
    window.scrollTo(0, 0);
  };
  BillDetail = () => {
    return (
      <React.Fragment>
        <h4>
          <strong>
            {" "}
            <FormattedMessage
              id="billPay.details"
              defaultMessage="Your bill details"
            />
          </strong>
        </h4>
        {this.state.fetchBillResponse.map((bill, index) => {
          return (
            <div className="mt-4" key={`fetchBill${index}`}>
              <div className="row justify-content-between border-bottom mt-3">
                <div className="col-6">
                  <p>{this.state.service.provider_label}:</p>
                </div>
                <div className="col-6 text-right">
                  <strong>
                    {this.state.provider ? this.state.provider.name : ""}
                  </strong>
                </div>
              </div>
              {bill.display.map((entry, index) => {
                return (
                  <React.Fragment key={`display${index}`}>
                    {this.state.provider &&
                      this.state.provider.parameters.map((parameter, index) => {
                        return (
                          parameter.key === "number" && (
                            <div
                              className="row justify-content-between border-bottom mt-3"
                              key={`param${index}`}
                            >
                              <div className="col-6">
                                <p>{parameter.value}:</p>
                              </div>
                              <div className="col-6 text-right">
                                <strong>{this.state.number}</strong>
                              </div>
                            </div>
                          )
                        );
                      })}
                    <div
                      className="row justify-content-between border-bottom mt-3"
                      key={`parameter${entry.value}`}
                    >
                      <div className="col-6">
                        <p>{entry.key}:</p>
                      </div>
                      <div className="col-6 text-right">
                        <strong>{entry.value}</strong>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          );
        })}
        <div className="row">
          <div className="col-8">
            {this.state.isLoading ? (
              <InlineLoader />
            ) : (
              <button
                type="button"
                className="btn btn-primary btn-block mb-3 mt-5 git home-btn"
                onClick={this.onInitOrder}
              >
                <FormattedMessage
                  id="billpay.proceed-to-pay"
                  defaultMessage="PROCEED TO PAY"
                />
              </button>
            )}
          </div>
          <div className="col-4">
            <button
              type="button"
              className="btn btn-primary btn-block mb-3 mt-5 git home-btn"
              onClick={() =>
                this.setState({
                  isFetchBillSuccessful: false,
                })
              }
            >
              <FormattedMessage id="general.back" defaultMessage="Back" />
            </button>
          </div>
        </div>

        {this.state.fetchBillResponse.acceptPartPay && (
          <button
            type="button"
            className="btn btn-white btn-block mb-3 mt-3 git home-btn winds-link-color text-capitalize bill-detail-btn"
            onClick={this.openPartialPayment}
            style={{ letterSpacing: 0, fontSize: "1rem", textAlign: "left" }}
          >
            <img src={aboutBlue} alt="" className="mr-2 mb-1" />
            <strong>
              {" "}
              <FormattedMessage
                id="billPay.partial-payment"
                defaultMessage="Make Partial Payment"
              />
            </strong>
          </button>
        )}
      </React.Fragment>
    );
  };

  BillForm = (props) => {
    const params = props.params;
    const isWrpBenefitModelOpen = props.isWrpBenefitModelOpen;
    return (
      <React.Fragment>
        <h4>
          <strong>{this.state.service.name}</strong>
        </h4>
        <form onSubmit={(e) => e.preventDefault()}>
          {(Number(params.id) === 1 || Number(params.id) === 2) && (
            <React.Fragment>
              <div className="form-check form-check-inline mr-5">
                <input
                  className="form-check-input mr-3"
                  type="radio"
                  name="rechargeOptions"
                  id="prepaid"
                  value="1"
                  onChange={this.onMobileRechargeTypeChange}
                  checked={Number(params.id) === 1}
                />
                <label className="form-check-label" htmlFor="prepaid">
                  <FormattedMessage
                    id="billPay.prepaid"
                    defaultMessage="Prepaid"
                  />
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input mr-3"
                  type="radio"
                  name="rechargeOptions"
                  id="postpaid"
                  value="2"
                  onChange={this.onMobileRechargeTypeChange}
                  checked={Number(params.id) === 2}
                />
                <label className="form-check-label" htmlFor="postpaid">
                  <FormattedMessage
                    id="billPay.postpaid"
                    defaultMessage="Postpaid"
                  />
                </label>
              </div>
            </React.Fragment>
          )}

          <div className="form-group mt-4">
            <label className="text-secondary">
              <strong>{this.state.service.provider_label}</strong>
            </label>
            <select
              className="form-control operator-select"
              onChange={this.onSelectProvider}
              value={this.state.provider ? this.state.provider.id : ""}
            >
              <option value="-1">{`${this.props.intl.formatMessage({
                id: "general.select",
                defaultMessage: "Select",
              })} ${this.state.service.provider_label}`}</option>
              {this.state.providers.map((item, index) => {
                return (
                  <option
                    checked={
                      this.provider &&
                      Number(item.id) === Number(this.provider.id)
                    }
                    value={item.id}
                    key={"providor-option-" + index}
                  >
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
          {null !== this.state.service && Number(params.id) === 1 && (
            <div className="form-group mt-4">
              <label className="text-secondary">
                <strong>
                  <FormattedMessage
                    id="billpay.choose-your-circle"
                    defaultMessage="Choose your circle"
                  />
                </strong>
              </label>
              <select
                className="form-control operator-select"
                id="default-operator"
                onChange={this.onSelectCircle}
              >
                {!this.state.circle && (
                  <option value="-1">
                    {this.props.intl.formatMessage({
                      id: "billpay.choose-your-circle",
                      defaultMessage: "Choose your circle",
                    })}
                  </option>
                )}
                {this.state.circles.map((item, index) => {
                  return (
                    <option
                      selected={this.state.circle === item.id}
                      value={item.id}
                      key={"circle-" + index}
                    >
                      {item.name}
                    </option>
                  );
                })}
              </select>
            </div>
          )}
          {null !== this.state.provider &&
            this.state.provider.parameters &&
            this.state.provider.parameters.length > 0 &&
            this.state.provider.parameters.map((parameter, index) => {
              return (
                <div className="form-group mt-4" key={index}>
                  {

                    !parameter.ishiddent &&

                    <label className="text-secondary">
                      <strong>{parameter.value}</strong>
                    </label>
                  }
                  {parameter.key === "number" && (
                    <React.Fragment>
                      <input
                        type="text"
                        id="default-mobile"
                        className="form-control operator-select"
                        onChange={(event) =>
                          this.onChangeNumber(event, parameter)
                        }
                        name={parameter.key}
                        value={this.state.number || ""}
                        onKeyDown={this.handleKeyDown}
                      />

                      <strong className="error-text">
                        {this.state.numberValidation}
                      </strong>
                    </React.Fragment>
                  )}

                  {parameter.key === "ad1" && !parameter.ishiddent &&
                    (parameter.options.length > 0 ? (
                      <select
                        className="form-control operator-select"
                        onChange={(event) =>
                          this.onChangeAccount(event, parameter)
                        }
                      >
                        <option value="-1">
                          {this.props.intl.formatMessage({
                            id: "general.select",
                            defaultMessage: "Select",
                          })}
                        </option>
                        {parameter.options.map((option, index) => {
                          return (
                            <option value={option} key={"options-" + index}>
                              {option}
                            </option>
                          );
                        })}
                      </select>
                    ) : (
                      <React.Fragment>
                        <input
                          id="default-consumer"
                          type={Number(params.id) === 7 ? "date" : "text"}
                          className="form-control operator-select"
                          onChange={(event) =>
                            this.onChangeAccount(event, parameter)
                          }
                          name={parameter.key}
                          value={this.state.account || ""}
                          onKeyDown={this.handleKeyDown}
                        />

                        <strong className="error-text">
                          {this.state.ad1Validation}
                        </strong>
                      </React.Fragment>
                    ))}

                  {parameter.key === "ad2" && (
                    <React.Fragment>
                      <input
                        type="text"
                        className="form-control operator-select"
                        onChange={this.onChangeAuthenticator}
                        name={parameter.key}
                        value={this.state.authenticator || ""}
                        onKeyDown={this.handleKeyDown}
                      />

                      <strong className="error-text">
                        {this.state.ad2Validation}
                      </strong>
                    </React.Fragment>
                  )}
                </div>
              );
            })}
          {null !== this.state.number &&
            this.state.provider &&
            !this.state.provider.is_fetch_bill && (
              <div className="form-group mt-4">
                <label className="text-secondary">
                  <FormattedMessage
                    id="general.amount"
                    defaultMessage="Amount"
                  />
                </label>
                {1 === parseInt(params.id) ? (
                  <div className="input-group mb-3">
                    <input
                      id="default-account"
                      type="text"
                      className="form-control operator-select"
                      value={this.state.amount || ""}
                      onChange={this.onAmountChange}
                    />
                    <div className="input-group-append">
                      <span
                        className="input-group-text"
                        onClick={this.handleShow}
                        style={{ cursor: "pointer" }}
                      >
                        <FormattedMessage
                          id="billpay.view-plans"
                          defaultMessage="View Plans"
                        />
                      </span>
                      {/* <this.ViewPlans /> */}
                      {this.ViewPlans()}
                    </div>
                  </div>
                ) : (
                  <input
                    type="text"
                    id="default-amount"
                    className="form-control operator-select"
                    value={this.state.amount || ""}
                    onChange={this.onAmountChange}
                  />
                )}
              </div>
            )}

          <div className="row mt-3 align-items-center">
            <div className="col-12">
              {this.state.isLoading ? (
                <InlineLoader />
              ) : this.state.provider &&
                this.state.provider &&
                this.state.provider.is_fetch_bill ? (
                <button
                  type="button"
                  className="btn btn-primary btn-block mb-3 mt-3 git home-btn w-50"
                  onClick={this.onFetchBill}
                  disabled={!this.state.number}
                >
                  <FormattedMessage
                    id="billpay.fetch-bill"
                    defaultMessage="Fetch Bill"
                  />
                </button>
              ) : this.state.service.name === "Mobile" ? (
                <button
                  type="button"
                  className="btn btn-primary btn-block mb-3 mt-3 git home-btn w-50"
                  onClick={this.onInitOrder}
                  disabled={this.state.payBtnState || this.state.circle === null}
                >
                  <FormattedMessage
                    id="billpay.proceed-to-pay"
                    defaultMessage="PROCEED TO PAY"
                  />
                </button>
              ) :
                (
                  <button
                    type="button"
                    className="btn btn-primary btn-block mb-3 mt-3 git home-btn w-50"
                    onClick={this.onInitOrder}
                    disabled={this.state.payBtnState}
                  >
                    <FormattedMessage
                      id="billpay.proceed-to-pay"
                      defaultMessage="PROCEED TO PAY"
                    />
                  </button>
                )}

              <button
                type="button"
                className="btn btn-outline"
                style={{
                  color: "#087CD8",
                  marginTop: "-0.5rem",
                }}
                onClick={this.openWrpBenefitModel}
              >
                <img src={aboutBlue} alt="" className="mr-1" />{" "}
                <FormattedMessage
                  id="general.wrp_benefits"
                  defaultMessage="WRP Benefits"
                />
              </button>
            </div>
            {this.state.isWrpBenefitModelOpen && (
              // <this.WrpBenefitModel
              //   isWrpBenefitModelOpen={isWrpBenefitModelOpen}
              //   closeWrpModelHandler={this.closeWrpModelHandler}
              // />
              this.WrpBenefitModel(isWrpBenefitModelOpen, this.closeWrpModelHandler)
            )}
          </div>
          {this.state.transactions && this.state.transactions.length > 0 && (
            <PastTransactions
              transactions={this.state.transactions}
              repeat={(item) => this.repeatTransaction(item)}
            />
          )}
        </form>
      </React.Fragment>
    );
  };

  onDismissInfo = () => {
    this.setState({
      serviceDisable: false,
    });
  };


  Shimmer = (props) => {
    return (
      <div className="container-fluid py-3 py-md-5">
        <div className="row">
          <div className="col-md-12">
            <div className="box shine box-voucher-detail-logo"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="box shine box-voucher-detail-logo"></div>
          </div>
          <div className="col-md-6 pt-4 pt-md-0">
            <ContentLoader
              height={80}
              width={400}
              speed={2}
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            >
              <rect x="0" y="0" rx="2" ry="2" width="99" height="6" />
              <rect x="0" y="16" rx="2" ry="2" width="300" height="24" />
            </ContentLoader>
            <div className="box shine w-100" style={{ height: "38px" }}></div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <ContentLoader
              height={160}
              width={400}
              speed={2}
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            >
              <rect x="0" y="9" rx="0" ry="0" width="120" height="6" />
              <rect x="0" y="21" rx="0" ry="0" width="320" height="12" />
              <rect x="0" y="39" rx="0" ry="0" width="92" height="6" />
              <rect x="0" y="60" rx="0" ry="0" width="506" height="6" />
              <rect x="0" y="75" rx="0" ry="0" width="136" height="6" />
              <rect x="0" y="90" rx="0" ry="0" width="153" height="6" />
            </ContentLoader>
          </div>
          <div className="col-md-6"></div>
        </div>
      </div>
    );
  };

  render() {
    const {
      match: { params },
    } = this.props;
    const { isWrpBenefitModelOpen } = this.state;

    if (this.state.pageLoading)
      return (<this.Shimmer />)
    else
      return (
        null != this.state.service && (
          <div className="bill-pay-page">
            {this.state.serviceDisable && (
              <InfoDialog
                message={
                  <>
                    <FormattedMessageWithClass
                      className="mt-3 font-weight-bold"
                      id="rewards.soryy"
                      defaultMessage="Oops! Sorry we are unable to process your request at the moment. Please try again after some time."
                    />
                  </>
                }
                buttonTxt={
                  <>
                    <FormattedMessage id="profile.ok" defaultMessage="OK" />
                  </>
                }
                url={serviceDownImg}
                onDismiss={this.onDismissInfo}
              />
            )}
            <div
              className="container-fluid container-fluid--bill-pay-icon"
              style={{ backgroundColor: "#F2F6FA" }}
            >
              <div className="row pt-3 mb-3">
                <div className="col-12">
                  <small>
                    <Link to="/">
                      <FormattedMessage
                        id="breadcrumbs.home"
                        defaultMessage="Home"
                      />
                    </Link>
                  </small>{" "}
                  /{" "}
                  <small>
                  <Link to="/bill-pay">
                    <FormattedMessage
                      id="home.recharge-pay-bills"
                      defaultMessage="Recharge & Pay Bills"
                    />
                    </Link>
                  </small>{" "}
                  /{" "}
                  <small>
                    <strong>{this.state.service.name}</strong>
                  </small>
                </div>
              </div>

              <div className="row">
                {this.state.isErrorModalOpen && (
                  <ErrorModal
                    message={
                      <>
                        <FormattedMessage
                          id="billPay.no-bill"
                          defaultMessage="No bill is due"
                        />
                      </>
                    }
                    buttonTxt={
                      <>
                        <FormattedMessage id="profile.ok" defaultMessage="OK" />
                      </>
                    }
                    onDismiss={this.onDismissErrorModal}
                  />
                )}
                {this.state.isPartialAmtModalOpen && (
                  <PartialAmount
                    onPartialAmtModalClose={this.onPartialAmtModalClose}
                    onPartialAmountChange={(value) =>
                      this.onPartialAmountChange(value)
                    }
                  />
                )}
                {/* <div className="col-12">
                  <div className="d-none d-md-flex justify-content-around">
                    {this.state.services.map((item, index) => {
                      if (parseInt(item.id) === parseInt(params.id)) {
                        return (
                          <Link to={`/bill-pay/${item.id}`} key={index}>
                            <div
                              onClick={this.resetState}
                              key={"service-" + index}
                              style={{ textAlign: "center" }}
                            >
                              <div className="recharge-img-box">
                                <img
                                  src={item.app_image_url}
                                  className="mb-0"
                                  style={{ height: "50px" }}
                                  alt={item.name}
                                />
                              </div>
                              <p
                                className="mb-0"
                                style={{
                                  fontSize: "16px",
                                  textAlign: "center",
                                  color: "#333333",
                                  borderBottom: "solid 3px #0078D7",
                                }}
                              >
                                {item.name}
                              </p>
                            </div>
                          </Link>
                        );
                      }

                      return (
                        <Link to={`/bill-pay/${item.id}`} key={index}>
                          <div
                            key={"service-" + index}
                            style={{ textAlign: "center" }}
                          >
                            <div className="recharge-img-box">
                              <img
                                src={item.app_image_url}
                                className="mb-0"
                                style={{ height: "50px" }}
                                alt={item.name}
                              />
                            </div>
                            <p
                              className="mb-0"
                              style={{
                                fontSize: "15px",
                                textAlign: "center",
                                color: "#666",
                              }}
                            >
                              {item.name}
                            </p>
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                </div> */}
              </div>
            </div>

            {this.context.bill_pay ? (
              <Iframe
                source={`${process.env.REACT_APP_BASE_URL_BILLPAY_MAINTENANCE
                  }/${currentlySelectedLanguage()}`}
              ></Iframe>
            ) : (
              <div
                className="container-fluid"
                style={{ backgroundColor: "#F6F6F6" }}
              >
                <div className="row">
                  <div className="col-12">
                    <div className="card card--bill-pay-form">
                      <div className="card-body">
                        <div className="row font-proxima-nova mt-4">
                          <div className="col-md-5 col-12">
                            {this.state.isFetchBillSuccessful ? (
                              <this.BillDetail />
                            ) : (
                              <this.BillForm
                                params={params}
                                isWrpBenefitModelOpen={isWrpBenefitModelOpen}
                              />
                            )}
                          </div>
                          <div className="col-md-7 text-center">
                            <img
                              src={billPayCreative}
                              className="d-none d-md-inline mt-md-5"
                              alt="Bill Pay"
                              style={{ width: "70%" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row d-md-none">
                  <div className="col-12">
                    <h5 className="mt-3 mb-5" style={{ fontWeight: "bold" }}>
                      <FormattedMessage
                        id="billPay.other-service"
                        defaultMessage="Other Services"
                      />
                    </h5>
                    <div className="bill-pay-page-icon-container">
                      {this.state.services.map((item, index) => {
                        return (
                          <div className="bill-pay-service-icon" key={item.id}>
                            <Link to={`/bill-pay/${item.id}`}>
                              <div
                                key={"service-" + index}
                                style={{ textAlign: "center" }}
                              >
                                <img
                                  src={item.app_image_url}
                                  className="mb-3"
                                  style={{ height: "30px" }}
                                  alt="appImage"
                                />
                                <p
                                  className="mb-0"
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    color: "#666",
                                  }}
                                >
                                  {item.name}
                                </p>
                              </div>
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )
      )
  }
}

const mapStateToProps = (state) => {
  return {
    order: state.order,
    profile: state.global.profile,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    billPayCart: (billPayForm) => {
      dispatch(billPayCart(billPayForm));
    },
    billPay: (billPayPayload) => {
      dispatch(billPay(billPayPayload));
    },
    repeat: (repeatData) => {
      dispatch(setRepeatData(repeatData));
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(BillPayForm))
);
